import React from 'react';
// @ts-ignore
import { Field as FieldBlur } from 'redux-form-normalize-on-blur';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { formatPercent, unFormatPercent } from 'utils';

const FieldPercent = (props: any) => {
  const { change, clearfieldinform } = props;
  const emptyValue = '0.00%';
  return (
    <FieldBlur
      {...props}
      normalize={(val: any) => {
        if (!val) return '';
        const replaceComaWithDot = val.replace(',', '.');
        const onlyNumber = replaceComaWithDot.replace(/[A-Za-z]/g, '');
        return onlyNumber;
      }}
      onFocus={(e: any, fieldName: string) => {
        if (clearfieldinform) {
          const { value } = e.currentTarget;
          if (value === emptyValue) {
            change(clearfieldinform, fieldName, ' ');
          }
        }
      }}
      normalizeOnBlur={(val: any) => {
        if (val === '-') return '-';
        if (!val) return formatPercent(0);
        const unFormatted = unFormatPercent(val);

        const formated = formatPercent(unFormatted);

        return formated;
      }}
    />
  );
};

export default connect(null, { change: change })(FieldPercent);
